export class FiltroListarSorteiosPorTipoESituacaoPortal {
    public tipoSorteio: number;
    public situacaoSorteio: number;
    public page: number;
    public pageSize: number;
  }


// WEBPACK FOOTER //
// ./src/app/shared/model/filtro-listar-sorteio-por-tipo-e-situacao.ts